import {
  QUERY_BUILDER_CLOSE_BRACKET,
  QUERY_BUILDER_OPEN_BRACKET,
  QueryBuilderInputContextType,
} from '../../../../types';

export type QueryBuilderBracketInsertType = 'open' | 'close';

export const resolveBracketInsertFromSearch = (
  context: QueryBuilderInputContextType,
  search: string,
  canOpenBracket: boolean,
  canCloseBracket: boolean
): QueryBuilderBracketInsertType | null => {
  if (search === QUERY_BUILDER_OPEN_BRACKET) {
    return context === 'expectOperand' && canOpenBracket ? 'open' : null;
  }

  if (search === QUERY_BUILDER_CLOSE_BRACKET) {
    return context === 'expectOperatorOrClose' && canCloseBracket ? 'close' : null;
  }

  return null;
};
